module.exports = __webpack_public_path__ + "static/media/6.be63dbf1.png";